import type { JSX } from 'react';
import styles from './Separator.css';

function Separator(): JSX.Element {
  return <div role="separator" className={styles.separator} />;
}

export default Separator;
